import { AgxIdentityVerificationExports } from '@urbanx/agx.ui-components2'
import { MenuTitles, Pages } from 'constants/menu'
import { useSelectedCampaign, useSelectedContract } from 'hooks'
import { ContractSubPage } from '../ContractSubPage'
import TerminateContractAction from '../TerminateContractAction'
import { getBuyerDetailsSubPages } from './BuyerDetailsSubPages'

const BuyerIdentityVerification = () => {
  const { campaign } = useSelectedCampaign()
  const { contract } = useSelectedContract()

  return (
    <ContractSubPage
      pageTitle="Buyer Details"
      secondaryActiveMenu={MenuTitles.BUYERS_DETAILS}
      currentPage={Pages.BUYERS_IDENTITY_VERIFICATION}
      subPages={getBuyerDetailsSubPages(campaign?.state)}
      onSaveChanges={() => undefined}
      isFormDirty={false}
      isSaving={false}
      isError={false}
      secondaryActions={<TerminateContractAction />}
      hideSaveButton
    >
      <AgxIdentityVerificationExports
        id="BuyerIdentityVerificationExports"
        campaignId={campaign?.campaignId ?? ''}
        contractId={contract?.contractId ?? ''}
        mode="buyers"
      />
    </ContractSubPage>
  )
}

export default BuyerIdentityVerification
